<div class="h-[100dvh] lg:h-screen w-full">
  <div
    class="relative h-full w-full flex justify-center items-center overflow-hidden rounded-br-[200px] md:rounded-br-[350px] shadow-2xl shadow-black/75">
    <video
      class="w-full h-full object-cover overflow-hidden"
      [loop]="true" [autoplay]="true" [muted]="true" poster="assets/parking/images/parking-video-cover.jpg">
      <source src="assets/parking/videos/pw-parking-hero.mp4" type="video/mp4"/>
    </video>
    <div
      class="absolute bg-black/60 left-0 top-0 h-screen w-full flex flex-col justify-center items-center px-10 md:px-20 lg:px-32 gap-16 text-center">
      <div class="flex flex-col gap-2 text-2xl md:text-14xl xl:text-16xl font-extrabold">
        <h1 i18n="@@autopark.hero.title" class="max-w-[1000px] text-secondary-400 font-secondary">
          Zwolnij flotę z kosztów parkingów<br>
          <span class="text-primary-500 inline-block">
              @if (isBrowser) {
                <om-number-ticker
                  styleClass="!w-[4ch] !text-right"
                  [countTo]="parkingTargetCapacity"
                  [countDuration]="parkingCapacityCounterDuration">
                </om-number-ticker>
              }
            miejsc od ręki w Warszawie
            </span>
        </h1>
        <span i18n="@@autopark.hero.subtitle"
              class="text-secondary-400 max-md:text-md md:text-lg xl:text-xl font-normal">
        <strong>Bezpieczne, wybrukowane miejsce</strong>  do przechowywania samochodów <br> dla firm leasingowych, importerów i dużych flot
      </span>
      </div>
      <button class="button font-bold text-base md:text-xl lg:text-2xl">
      </button>
      <p-button
        (click)="trackRequestCta()"
        i18n-label="@@button.send-request"
        label="Wyślij zapytanie"
        class="extra-padding"
        [rounded]="true"
        [navigator]="formComponentSignal()?.id">
      </p-button>
    </div>
  </div>
</div>
